//
// Version Manager is a javascript class that restricts access to any
// elements that should not be available to earlier versions of the TD
// Mobile app.
//
// This class relies on the "data-mobile-app-version" attribute on the
// <body> element, and a "data-minimum-version" and "data-version-error"
// attributes on the elements that need to be restricted.
//
// jQuery: 1.11.1
//-------------------------------------------------------------------------

(function ($, window) {

	VersionManager_Class = function () {
		this._currentVersion = this._getCurrentVersion();
		this._getCurrentVersion();
		this._cacheElements();
		this._attachEvents();
	};

	VersionManager_Class.prototype._getCurrentVersion = function () {
		return  $('body').data('mobile-app-version');
	};

	VersionManager_Class.prototype._cacheElements = function () {
		// For elements that need have a data-verison-hide, hide them
		this._elementsToBeHidden = $('[data-minimum-version][data-version-hide], [data-maximum-version][data-version-hide]');
		// For elements that have a data-version-error, display an error when clicked
		this._elementsToDisplayError = $('[data-minimum-version][data-version-error], [data-maximum-version][data-version-error]');
	};

	VersionManager_Class.prototype._attachEvents = function () {
		// For elements that need have a data-verison-hide, hide them
		this._elementsToBeHidden.each($.proxy(this._handleHide, this));
		// For elements that have a data-version-error, display an error when clicked
		this._elementsToDisplayError.click($.proxy(this._handleClick, this));
	};

	VersionManager_Class.prototype._handleClick = function (event) {
		var $element = $(event.currentTarget);

		// Stop the underlying click event
		if (this._isElementRestricted($element)) {
			event.stopImmediatePropagation();
			event.preventDefault();
			this._showErrorFor($element);

			// Return the page to its normal state
			nativeInteractions.mobileLoader.hide();
			return false;
		}

		// Let the underlying click events process
		return true;
	};

	VersionManager_Class.prototype._handleHide = function (i, el) {
		var $element = $(el);
		if (this._isElementRestricted($element)) {
			$element.hide();
		}
	};

	// An element is restricted if it:
	// 1. Has a minimum version and current version wasn't provided
	// or
	// 2. Has a minimum version and that minimum version is greater than the current version
	VersionManager_Class.prototype._isElementRestricted = function ($element) {

		var minimumVersion = $element.data('minimum-version');
		var maximumVersion = $element.data('maximum-version');

		var isRestricted;

		if (minimumVersion) {
			isRestricted = !this._currentVersion || minimumVersion > this._currentVersion;
		}
		if (maximumVersion) {
			isRestricted = !this._currentVersion || maximumVersion < this._currentVersion;
		}

		return isRestricted;
	};

	VersionManager_Class.prototype._showErrorFor = function ($element) {
		if ($element.data('version-error')) {
			alert($element.data('version-error'));
		} else {
			alert('To access this feature, please update your mobile app.');
		}
	};
	/*
		After an Ajax call that brought in dynamic content search the page for new elements that might need to be hidden
	*/
	VersionManager_Class.prototype.refresh = function () {
		this._currentVersion = this._getCurrentVersion();
		this._cacheElements();
		this._attachEvents();
	};

	VersionManager_Class.prototype.isVersionGreaterThan = function (versionNeeded) {
		return this._currentVersion > versionNeeded;
	};

	window.VersionManager = window.VersionManager || new VersionManager_Class();

})(jQuery, window);